import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";

//---------------------------------------------

// GET =>  get Classes For School
export const getClassesForSchool = createAsyncThunk(
  "class/getClassesForSchool",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.getClassesForSchoolURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  get All Classes
export const getAllClasses = createAsyncThunk(
  "class/getAllClasses",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.getAllClassesURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST =>  add ClassesToSchool
export const addClassesToSchool = createAsyncThunk(
  "class/addClassesToSchool",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.addClassesToSchoolURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
